import axios from 'axios';
import Qs from 'qs';

// axios.defaults.withCredentials = false;
//
// axios.defaults.baseURL = /mingchezhantai/.test(location.host) ? 'http://api.mingchezhantai.com' : 'http://api.qichezhidao.com';
// // axios.defaults.baseURL = 'http://localhost:8090';
//
// axios.interceptors.request.use(request => {
//     return request;
// });
//
// // 设置拦截器
// axios.interceptors.response.use((response) => {
//     return response;
// }, (err) => {
//     // if(err.response){
//
//     // }
//     return Promise.reject(err);
// });
// export default axios;




const API_HOST = /mingchezhantai/.test(location.host) ? 'http://api.mingchezhantai.com/' : 'http://api.qichezhidao.com/'
window.XX_API_HOST = API_HOST

// create an axios instance
const service = axios.create({
    // baseURL: process.env.HOST, // api 的 base_url
    baseURL: API_HOST,
    // baseURL: 'http://localhost:8090/',
    timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        // Do something before request is sent

        return config
    },
    error => {
        // Do something with request error
        console.log(error) // for debug
        Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    // response => response,
    /**
     * 下面的注释为通过在response里，自定义code来标示请求状态
     * 当code返回如下情况则说明权限有问题，登出并返回到登录页
     * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
     * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
     */
    response => {
        return response;

    },
    error => {
        return Promise.reject(error)
    }
)

export default service

export const requestPost = function (url, data) {
    data = Qs.stringify(data);

    return service({
        url: url,
        method: 'post',
        params: {},
        data
    });
}
